export enum EquipSlot {
  Ears = "ears",
  Watches = "watches",
  Mask = "mask",
  Shoes = "shoes",
  Accessories = "accessories",
  Hands = "hands",
  Bracelets = "bracelets",
  Legs = "legs",
  Bags = "bags",
  BodyArmors = "bodyArmors",
  Tops = "tops",
  Hat = "hat",
  Glasses = "glasses",
  Gloves = "gloves",
}
